import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_WEB_ZAPPOS_REBRAND } from 'constants/features';
import useMartyContext from 'hooks/useMartyContext';

export const useIsZapposRebrand = () => {
  const { marketplace } = useMartyContext();
  const { isEnrolled: isZapposRebrand } = useIsEnrolledInVariant(FEATURE_WEB_ZAPPOS_REBRAND);

  return marketplace.theme === 'zappos' ? isZapposRebrand : false;
};
